// component
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;
// state:'disabled' for disabled link
// state:'block' for visable & clickable link

const navConfig = [



  {
    title: 'Contact us - تواصل معنا',
    path: '/help-center/contact',
    icon: getIcon('eva:flash-outline'),
    state: 'block',
  },

  // {
  //   title: 'Graphic artists',
  //   path: '#',
  //   icon: getIcon('eva:color-palette-outline'),
  //   state: 'block',
  // },
];

export default navConfig;
